import { BeachAccess, SickOutlined, Weekend, WatchOff } from "@mui/icons-material";

export type TimeOffType = "holiday" | "sick_leave" | "day_off" | "missed_justified" | "missed_not_justified";

type TimeOffConfig = {
    label: string;
    colorKey: "secondary" | "error";
    icon: React.ReactNode;
};

export const TIME_OFF_CONFIG: Record<TimeOffType, TimeOffConfig> = {
    holiday: { label: "Férias", colorKey: "secondary", icon: <BeachAccess /> },
    sick_leave: { label: "Baixa", colorKey: "error", icon: <SickOutlined /> },
    day_off: { label: "Folga", colorKey: "secondary", icon: <Weekend /> },
    missed_justified: { label: "Falta Justificada", colorKey: "error", icon: <WatchOff /> },
    missed_not_justified: { label: "Falta não justificada", colorKey: "error", icon: <WatchOff /> },
};

export const getTimeOffConfig = (type: TimeOffType) => {
    const config = TIME_OFF_CONFIG[type];
    return config;
};

